document.addEventListener('DOMContentLoaded', function () {

  const dateInput = document.getElementById('pickup-date');
  const hiddenInput = document.getElementById('pickup-date-hidden');

  if (!dateInput || !hiddenInput) return;

  const DAYS = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado'
  ];

  const MONTHS = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre'
  ];

  function pad(number) {
    return number.toString().padStart(2, '0');
  }

  function toISO(date) {
    return (
      date.getFullYear() + '-' +
      pad(date.getMonth() + 1) + '-' +
      pad(date.getDate())
    );
  }

  function formatSpanish(date) {
    return (
      DAYS[date.getDay()] +
      ' ' +
      date.getDate() +
      ' de ' +
      MONTHS[date.getMonth()] +
      ' de ' +
      date.getFullYear()
    );
  }

  function firstAvailableDate() {

    const now = new Date();

    let pickup = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const day = now.getDay();

    const minutes = now.getHours() * 60 + now.getMinutes();

    // Domingo
    if (day === 0) {
      pickup.setDate(pickup.getDate() + 1);
      return pickup;
    }

    // Lunes a Viernes
    if (day >= 1 && day <= 5) {

      if (minutes >= (15 * 60)) {
        pickup.setDate(pickup.getDate() + 1);
      }

    }

    // Sábado
    if (day === 6) {

      if (minutes >= (11 * 60 + 30)) {
        pickup.setDate(pickup.getDate() + 2);
      }

    }

    while (pickup.getDay() === 0) {
      pickup.setDate(pickup.getDate() + 1);
    }

    return pickup;

  }

  const minimum = firstAvailableDate();

  dateInput.min = toISO(minimum);

  dateInput.addEventListener('change', function () {

    if (!this.value) {
      hiddenInput.value = '';
      return;
    }

    const parts = this.value.split('-');

    const selected = new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );

    if (selected.getDay() === 0) {

      alert('Los domingos no hay servicio de recolección.');

      this.value = '';

      hiddenInput.value = '';

      return;

    }

    const formattedDate = formatSpanish(selected);

      hiddenInput.value = formattedDate;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Fecha preferida de recolección': formattedDate
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Fecha de recolección guardada.', data.attributes);
      })
      .catch(error => {
        console.error('Error al guardar la fecha:', error);
      });

  });

});